import axios from "axios";
import { GET_FOTOR_BASE_URL, getFotorXAppId } from "@Common";


const service = axios.create({
    baseURL: GET_FOTOR_BASE_URL()
});

/**
 * 注销 Fotor 账号
 * @param token token 
 * @returns 
 */
export function cancelFotorAccount(token: string) {
    return service({
        url: "/api/user/cancel-account",
        method: "get",
        headers: {
            "x-app-id": getFotorXAppId(),
            Authorization: 'bearer ' + token
        },
    });
}

/**
 * 获取 Fotor 账号注销状态
 * @param token token 
 * @returns 
 */
export function getFotorCancelStatus(token: string) {
    return service({
        url: "/api/user/cancellation",
        method: "get",
        headers: {
            "x-app-id": getFotorXAppId(),
            Authorization: 'bearer ' + token
        },
        withCredentials: true,
    });
}

/**
 * 撤销 Fotor 账号注销申请
 * @param token token
 * @returns 
 */
export function withdrawalDeleteFotorAccount(token: string) {
    return service({
        url: "/api/user/undo-cancel",
        method: "delete",
        headers: {
            "x-app-id": getFotorXAppId(),
            Authorization: 'bearer ' + token
        },
    });
}